export class DateRangeFilter
{
    StartDate:any;
    EndDate:any;
}